import React from 'react'

import FaqSection from '../../../react4xp/components/FaqSection'

function HeroPart({title, intro, questions, bgColor, maskColor}) {
	return (
		<FaqSection 
			title={title}
			desc={intro}
			accordion={questions}
			section={{
				bgColor: bgColor
			}}
			maskColor={maskColor}
		/>	
	)
}

export default (props) => <HeroPart {...props} />
